import React from 'react';
import '../../App.css';
import '../../bootstrap.css';
import * as Database from '../../helpers/Database';
import DataEntryTodoForm from './DataEntryTodoForm';
import NotesBox2 from './NotesBox2';
import LoggedFoodsTable from './LoggedFoodsTable';
import RemindersPage from '../reminders/RemindersPage';
import * as Analytics from '../../helpers/Analytics';
import {
  getPrevDateString, getLocalDateString, mapDataEntryToFirebaseFoodEntry, updateFoodEntryHistories,
  mergeFoodFormEntryWithFirebaseEntry, buildRevisionHistory, getNumHoursPassedInLocalTime, NUTRITION_DATA, isCopiedThenCorrectedFood
} from '../../helpers/Util';
import { getTimestampFromTodoList } from '../../helpers/TodoUtil';
import RecipeBuilder from './RecipeBuilder';
//import { RFC_2822 } from 'moment';
let _ = require('lodash');

// KEEP THIS IN SYNC WITH vivaapi
//   9/26/23: Commenting these out and hard-coding them inline instead to see if this fixes https://app.asana.com/0/286104021310008/1205585706164330
// const OMIT_FROM_TURNAROUND_TIME_ANALYTICS = ["eJlGmvsAGMfjqh4bCdcUAEkgcF63"];

const OPTION = {
  DataEntry: 'dataEntry',
  Reminders: 'reminders',
  RecipeBuilder: 'recipeBuilder'
}

export default class UserPanel2 extends React.Component {
  constructor(props) {
    super(props);
    this.allLoggedFoodsCache = {};
    this.foodReportsCache = {};
    this.foodReportsAveragesCache = {};
    this.foodTargetsCache = {};
    this.state = {
      everythingConfirmed: this._isEverythingConfirmed(),
      targetDate: this._getInitialTargetDate(),
      allLoggedFoods: this.allLoggedFoodsCache,
      foodReports: this.foodReportsCache,
      foodReportsAverages: this.foodReportsAveragesCache,
      foodTargets: this.foodTargetsCache,
      selectedOption: OPTION.DataEntry,
      errorMessage: ''
    };

    this._initFoodLogAndTargetListenersAsync(this.state.targetDate, this.props.userId);
    this._resetTimeSpent(null, this.props.userId);
  }

  _getInitialTargetDate() {
    return getLocalDateString(new Date(), this.props.userStatus.timezoneOffset)
  }

  componentWillUnmount() {
    this._unsubFoodLogAndTargetListeners();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userId != this.props.userId) {
      this._unsubFoodLogAndTargetListeners();
      this._clearFoodAndTargetCaches();
      let initialTargetDate = this._getInitialTargetDate();
      this._initFoodLogAndTargetListenersAsync(initialTargetDate, nextProps.userId);
      this._resetTimeSpent(this.props.userId, nextProps.userId);
      this.setState({
        targetDate: initialTargetDate
      });
    }
  }

  _unsubFoodLogAndTargetListeners = () => {
    if (this.unsubFoodLogListener) {
      this.unsubFoodLogListener();
    }

    if (this.unsubFoodTargetsListener) {
      this.unsubFoodTargetsListener();
    }

    if (this.unsubFoodReportsListener) {
      this.unsubFoodReportsListener();
    }
  }

  _initFoodLogAndTargetListenersAsync = async (targetDate, userId) => {
    this.unsubFoodTargetsListener = await Database.initFoodTargetsListenerAsync(
      userId,
      targetDate,
      async (data, id) => {
        await this._updateFoodTargetsStateAsync(data, id);
      },
      async (id) => {
        await this._updateFoodTargetsStateAsync(null, id);
      });

    this.unsubFoodReportsListener = Database.initFoodReportsListener(
      userId,
      targetDate,
      async (data, id) => {
        await this._updateFoodReportsStateAsync(data, id, targetDate);
      },
      async (id) => {
        await this._updateFoodReportsStateAsync(null, id, targetDate);
      });

    this.unsubFoodLogListener = Database.initLoggedFoodsListener(
      userId,
      targetDate,
      async (data, id) => {
        await this._updateFoodLogsStateAsync(data, id);
      },
      async (id) => {
        await this._updateFoodLogsStateAsync(null, id);
      });
  }

  _resetTimeSpent = async (currUserId, nextUserId) => {
    if (currUserId !== null) {
      const totalTimeSpent = await this._getTotalTimeSpentOnThisUser(currUserId);
      if (totalTimeSpent !== null) {
        // If totalTimeSpnt is null, then it's possible this todo doc no longer exists in the database and thus we shouldn't update it.
        Database.setTimeSpentOnUserTodo(currUserId, totalTimeSpent);
      }
    }

    this.depStartTimeForThisUser = Date.now();
  }

  _getTotalTimeSpentOnThisUser = async (userId) => {
    const timeElapsed = Date.now() - this.depStartTimeForThisUser;
    const oldTimeSpent = await Database.getTimeSpentOnUserTodo(userId);
    if (oldTimeSpent === null) {
      // Null = this todo no longer exists in the database.
      return null;
    }
    return oldTimeSpent + timeElapsed;
  }

  _updateFoodTargetsStateAsync = async (data, id) => {
    if (data === null || data === undefined) {
      delete this.foodTargetsCache[id];
    } else {
      this.foodTargetsCache[id] = data;
    }

    this.setState({
      foodTargets: this.foodTargetsCache,
    });
  }

  _updateFoodLogsStateAsync = async (data, id) => {
    if (data === null || data === undefined) {
      delete this.allLoggedFoodsCache[id];
    } else {
      this.allLoggedFoodsCache[id] = data;
    }

    this.setState({
      allLoggedFoods: this.allLoggedFoodsCache
    });
  }

  _updateFoodReportsStateAsync = async (report, id, targetDate) => {
    if (report === null || report === undefined) {
      delete this.foodReportsCache[id];
      delete this.foodReportsAveragesCache[id];
    } else {
      this.foodReportsCache[id] = report;

      var dateTMinus1 = getPrevDateString(targetDate);
      var reportForTMinus1 = await Database.getFoodReports(this.props.userId, dateTMinus1);

      var dateTMinus2 = getPrevDateString(dateTMinus1);
      var reportForTMinus2 = await Database.getFoodReports(this.props.userId, dateTMinus2);

      var dateTMinus3 = getPrevDateString(dateTMinus2);
      var reportForTMinus3 = await Database.getFoodReports(this.props.userId, dateTMinus3);

      var dateTMinus4 = getPrevDateString(dateTMinus3);
      var reportForTMinus4 = await Database.getFoodReports(this.props.userId, dateTMinus4);

      var dateTMinus5 = getPrevDateString(dateTMinus4);
      var reportForTMinus5 = await Database.getFoodReports(this.props.userId, dateTMinus5);

      var dateTMinus6 = getPrevDateString(dateTMinus5);
      var reportForTMinus6 = await Database.getFoodReports(this.props.userId, dateTMinus6);

      if (this.state.foodTargets && id in this.state.foodTargets) {
        this.foodReportsAveragesCache[id] = this._computeWeeklyAverage(id, report, targetDate,
          reportForTMinus1, reportForTMinus2, reportForTMinus3, reportForTMinus4, reportForTMinus5, reportForTMinus6);
      }
    }

    this.setState({
      foodReports: this.foodReportsCache,
      foodReportsAverages: this.foodReportsAveragesCache
    });
  }

  _computeWeeklyAverage = (foodTargetId, report, targetDate,
    reportsForTMinus1, reportsForTMinus2, reportsForTMinus3, reportsForTMinus4, reportsForTMinus5, reportsForTMinus6
  ) => {
    let weeklyAverageConsumed = 0;
    let totalDaysWithAnythingConsumed = 0;
    let targetDayHasAnythingConsumed = false;

    if (report != null) {
      var totalConsumed = _.round(report.total);
      if (totalConsumed > 0) {
        weeklyAverageConsumed = weeklyAverageConsumed + _.round(report.total);
        totalDaysWithAnythingConsumed = totalDaysWithAnythingConsumed + 1;
        targetDayHasAnythingConsumed = true;
      }
    }

    if (foodTargetId in reportsForTMinus1) {
      var reportForDateMinus1 = reportsForTMinus1[foodTargetId];
      if (reportForDateMinus1 != null) {
        var totalConsumed = _.round(reportForDateMinus1.total);
        if (totalConsumed > 0) {
          weeklyAverageConsumed = weeklyAverageConsumed + _.round(reportForDateMinus1.total);
          totalDaysWithAnythingConsumed = totalDaysWithAnythingConsumed + 1;
        }
      }
    }

    if (foodTargetId in reportsForTMinus2) {
      var reportForDateMinus2 = reportsForTMinus2[foodTargetId];
      if (reportForDateMinus2 != null) {
        var totalConsumed = _.round(reportForDateMinus2.total);
        if (totalConsumed > 0) {
          weeklyAverageConsumed = weeklyAverageConsumed + _.round(reportForDateMinus2.total);
          totalDaysWithAnythingConsumed = totalDaysWithAnythingConsumed + 1;
        }
      }
    }

    if (foodTargetId in reportsForTMinus3) {
      var reportForDateMinus3 = reportsForTMinus3[foodTargetId];
      if (reportForDateMinus3 != null) {
        var totalConsumed = _.round(reportForDateMinus3.total);
        if (totalConsumed > 0) {
          weeklyAverageConsumed = weeklyAverageConsumed + _.round(reportForDateMinus3.total);
          totalDaysWithAnythingConsumed = totalDaysWithAnythingConsumed + 1;
        }
      }
    }

    if (foodTargetId in reportsForTMinus4) {
      var reportForDateMinus4 = reportsForTMinus4[foodTargetId];
      if (reportForDateMinus4 != null) {
        var totalConsumed = _.round(reportForDateMinus4.total);
        if (totalConsumed > 0) {
          weeklyAverageConsumed = weeklyAverageConsumed + _.round(reportForDateMinus4.total);
          totalDaysWithAnythingConsumed = totalDaysWithAnythingConsumed + 1;
        }
      }
    }

    if (foodTargetId in reportsForTMinus5) {
      var reportForDateMinus5 = reportsForTMinus5[foodTargetId];
      if (reportForDateMinus5 != null) {
        var totalConsumed = _.round(reportForDateMinus5.total);
        if (totalConsumed > 0) {
          weeklyAverageConsumed = weeklyAverageConsumed + _.round(reportForDateMinus5.total);
          totalDaysWithAnythingConsumed = totalDaysWithAnythingConsumed + 1;
        }
      }
    }

    if (foodTargetId in reportsForTMinus6) {
      var reportForDateMinus6 = reportsForTMinus6[foodTargetId];
      if (reportForDateMinus6 != null) {
        var totalConsumed = _.round(reportForDateMinus6.total);
        if (totalConsumed > 0) {
          weeklyAverageConsumed = weeklyAverageConsumed + _.round(reportForDateMinus6.total);
          totalDaysWithAnythingConsumed = totalDaysWithAnythingConsumed + 1;
        }
      }
    }

    // If on today, then get a fractional divisor proportional to how much of today has passed (rather thab counting it as 1 whole day).
    if (targetDate == this._getInitialTargetDate() &&
      targetDayHasAnythingConsumed &&
      totalDaysWithAnythingConsumed > 1) {
      var percentageOfCurrentDayPassed = getNumHoursPassedInLocalTime(this.props.userStatus.timezoneOffset) / 24;
      totalDaysWithAnythingConsumed =
        totalDaysWithAnythingConsumed - 1 + percentageOfCurrentDayPassed;
    }

    if (totalDaysWithAnythingConsumed > 0) {
      weeklyAverageConsumed = _.round(weeklyAverageConsumed / totalDaysWithAnythingConsumed);
    }

    return weeklyAverageConsumed;
  }

  _updateFoodReportsAsync = async () => {
    Database.requestReportRefresh(this.props.userId, this.state.targetDate);
  }

  _onTargetDateChange = (e) => { // Date change = unsub listeners, reset all state, resub listeners to new date.
    let date = e.target.value;
    this._unsubFoodLogAndTargetListeners();
    this._clearFoodAndTargetCaches();
    this._initFoodLogAndTargetListenersAsync(date, this.props.userId);
    this.setState({
      targetDate: date
    });
  }

  _clearFoodAndTargetCaches = () => {
    this.allLoggedFoodsCache = {};
    this.foodTargetsCache = {};
    this.foodReportsCache = {};
    this.setState({
      allLoggedFoods: this.allLoggedFoodsCache,
      foodTargets: this.foodTargetsCache,
      foodReports: this.foodReportsCache,
    });
  }


  _onLogEverythingAsync = async (e) => {
    this.setState({
      showLoadingMessage: true // show loading message since we have to wait for things to submit. Prevent DEP from spamming this button or else it mess up analytics.
    });

    let confirmedEntries = [];
    const now = Date.now();
    let userStartSearchTime = now;
    let adminLastLoggedTimestamp = 0;
    let skipLoggingSomeFoods = false;

    // Update turnaround time analytics before any updateFoodEntryHistories is called.
    const totalTimeSpent = await this._getTotalTimeSpentOnThisUser(this.props.userId);
    const timePassed = getTimestampFromTodoList(this.props.todoItems['newMessage']).timePassed;
    await Database.updateTurnaroundTimeAnalytics(this.props.userStatus.name, timePassed, totalTimeSpent, this.props.todoItems['newMessage']);

    for (let todoId in this.props.todoItems['newMessage']) {
      let dataEntryContent = this.props.todoItems['newMessage'][todoId].dataEntryContent;
      if (!dataEntryContent) { // back compat: This happens for archived items form messenger bot days. Can just skip.
        continue;
      }

      // If not manualPick, this entry isn't confirmed - this may hapen if new todo got added while DEP was submitting, but UI hasn't rendered it yet.
      if (!dataEntryContent.manualPick) {
        continue;
      }

      if (dataEntryContent.needsHelp) {
        skipLoggingSomeFoods = true;
      } else {
        let newRevisionHistoryEntry = buildRevisionHistory(
          dataEntryContent, dataEntryContent.consolidatedServingName, dataEntryContent.topHitName, this.props.adminId);

        // Error Validation
        if (dataEntryContent.revisionHistory && dataEntryContent.revisionHistory.includes(newRevisionHistoryEntry)) {
          this.setState({
            errorMessage: `You've already logged this same food for this same entry. Are you sure you made the right correction? This is what you tried to log: ${dataEntryContent.consolidatedServingName} ${dataEntryContent.topHitName}`
          });
          return;
        }

        for (let dataName of NUTRITION_DATA) {
          if (dataEntryContent[dataName] === null || dataEntryContent[dataName] === '' || _.toNumber(dataEntryContent[dataName]) === NaN) {
            dataEntryContent[dataName] = 0;
          }
        }

        updateFoodEntryHistories(dataEntryContent, dataEntryContent.consolidatedServingName, dataEntryContent.topHitName, null, this.props.adminId,);
        
        let confirmedFoodEntry = mapDataEntryToFirebaseFoodEntry(dataEntryContent, todoId);
        confirmedEntries.push(
          {
            'foodEntry': confirmedFoodEntry,
            'docId': todoId
          }
        );

        // For analytics on food submit. First get admin last logged timestamp. This should always be the most recent one.
        let latestAdminTimestamp = confirmedFoodEntry.loggedTimestamps[confirmedFoodEntry.loggedTimestamps.length - 1].timestamp;
        if (latestAdminTimestamp > adminLastLoggedTimestamp) {
          adminLastLoggedTimestamp = latestAdminTimestamp;
        }

        if (!dataEntryContent.lastNeededHelp /* Skip anything that was in NeedsHelp state */ &&
          /*!OMIT_FROM_TURNAROUND_TIME_ANALYTICS.includes(this.props.userId)*/
          this.props.userId != 'eJlGmvsAGMfjqh4bCdcUAEkgcF63' &&
          (dataEntryContent.startSearchTime !== null && dataEntryContent.startSearchTime !== undefined)) {

          const latestStartSearchTime = dataEntryContent.startSearchTime;
          if (latestStartSearchTime < userStartSearchTime) {
            userStartSearchTime = latestStartSearchTime;
          }
        }
      }
    }

    if (userStartSearchTime === now) {
      userStartSearchTime = 0; // If found no eligible userStartSearchTime in the block above, set to 0 to indicate nothing found.
    }

    if (skipLoggingSomeFoods) {
      // If any todos are marked as needsHelp at the time of submission, then flag the pending logs collection of this user has
      // 'everythingNeedsHelp' since after logging everything else, all that will remian in their pending foods will be ones that need help.
      await Database.updatePendingLogsForUserAsync(this.props.userId, {
        'everythingNeedsHelp': true,
      });
    }

    await Database.logAllFoodsAndReportsAsync(
      this.props.userId,
      confirmedEntries,
      Database.SUBMIT_FOOD_INTENTION.AddOrCorrect,
      skipLoggingSomeFoods
    );

    this.setState({
      everythingConfirmed: false,
      errorMessage: ''
    })

    if (adminLastLoggedTimestamp > 0 && userStartSearchTime > 0 /* Can be 0 if the todo being logged was marked NeedsHelp at some point*/) {
      // Its possible that neither LastLoggedTimestamps have been updated if all the todos in this batch are marked as needsHelp.
      Analytics.logFoodSubmitForm(this.props.userId, this.props.adminId, (adminLastLoggedTimestamp - userStartSearchTime) / 1000, totalTimeSpent / 1000, confirmedEntries.length);
    }

    this.setState({
      showLoadingMessage: false
    })
  }

  _onItemConfirmedOrStatusChange = () => {
    const everythingConfirmed = this._isEverythingConfirmed();
    if (everythingConfirmed != this.state.everythingConfirmed) {
      this.setState({
        everythingConfirmed: everythingConfirmed
      });
    }

    if (this._isEverythingNeedsHelp()) {
      // If all todos are marked as needsHelp at the time of this check, then flag the pending logs collection of this user as
      // 'everythingNeedsHelp' since after logging everything else, all that will remian in their pending foods will be ones that need help.
      Database.updatePendingLogsForUserAsync(this.props.userId, {
        'everythingNeedsHelp': true,
      });
    }
  }

  _isEverythingConfirmed = () => {
    let everythingConfirmed = true;
    for (let todoId in this.props.todoItems['newMessage']) {
      if (this.props.todoItems['newMessage'][todoId].dataEntryContent &&
        !this.props.todoItems['newMessage'][todoId].dataEntryContent.manualPick &&
        !this.props.todoItems['newMessage'][todoId].dataEntryContent.needsHelp
      ) {
        everythingConfirmed = false;
        break;
      }
    }
    return everythingConfirmed;
  }

  _isEverythingNeedsHelp = () => {
    let everythingNeedsHelp = true;
    for (let todoId in this.props.todoItems['newMessage']) {
      if (!this.props.todoItems['newMessage'][todoId].dataEntryContent.needsHelp
      ) {
        everythingNeedsHelp = false;
        break;
      }
    }
    return everythingNeedsHelp;
  }

  _handleOptionChange = (e) => {
    //this.clearLoggingInputs();
    this.setState({
      selectedOption: e.target.value
    });
  }

  _deleteFood = async (userId, targetDate, docId) => {
    await Database.deleteFood(userId, targetDate, docId);
  }

  _correctFood = async (userId, existingFirebaseEntry, newFoodFormEntry, docId) => {
    updateFoodEntryHistories(existingFirebaseEntry, newFoodFormEntry.consolidatedServingName, newFoodFormEntry.name, newFoodFormEntry, this.props.adminId);
    let firebaseFoodEntry = mergeFoodFormEntryWithFirebaseEntry(existingFirebaseEntry, newFoodFormEntry, docId);
    await Database.logAllFoodsAndReportsAsync(
      userId,
      [{ 'foodEntry': firebaseFoodEntry, 'docId': docId }],
      Database.SUBMIT_FOOD_INTENTION.Correct,
      false
    );
    return { error: null };
  }

  render() {
    let selectedOptionUI = (<span />);
    if (this.state.selectedOption === OPTION.Reminders) {
      selectedOptionUI = (
        <RemindersPage firebase={this.props.firebase} userName={this.props.userId} userId={this.props.userId} />
      );
    } else if (this.state.selectedOption === OPTION.RecipeBuilder) {
      selectedOptionUI = (
        <div>
          <RecipeBuilder
            userId={this.props.userId}
            targetDate={this.state.targetDate}
            userStatus={this.props.userStatus}
            adminId={this.props.adminId}
            emptyCartAfterSubmit={true}
          />
          <hr />
        </div>
      );
    }

    let uiOptions = this.props.dataEntryMode ?
      <form style={{ textAlign: "center" }}>
        <input type="radio" value={OPTION.DataEntry} checked={this.state.selectedOption === OPTION.DataEntry} onChange={this._handleOptionChange} /><b>Data Entry</b>
        <input style={{ marginLeft: '10px' }} type="radio" value={OPTION.RecipeBuilder} checked={this.state.selectedOption === OPTION.RecipeBuilder} onChange={this._handleOptionChange} /><b>Recipe Builder</b>
      </form> :
      <form style={{ textAlign: "center" }}>
        <input type="radio" value={OPTION.DataEntry} checked={this.state.selectedOption === OPTION.DataEntry} onChange={this._handleOptionChange} /><b>Data Entry</b>
        <input style={{ marginLeft: '10px' }} type="radio" value={OPTION.Reminders} checked={this.state.selectedOption === OPTION.Reminders} onChange={this._handleOptionChange} /><b>Reminders</b>
        <input style={{ marginLeft: '10px' }} type="radio" value={OPTION.RecipeBuilder} checked={this.state.selectedOption === OPTION.RecipeBuilder} onChange={this._handleOptionChange} /><b>Recipe Builder</b>
      </form>;

    let dataEntryTodoForms = <span />
    if (this.props.todoItems['newMessage']) {
      dataEntryTodoForms = Object.keys(this.props.todoItems['newMessage']).map((todoId) => {
        let dataEntryTodo = this.props.todoItems['newMessage'][todoId];
        return dataEntryTodo.dataEntryContent ? (
          <DataEntryTodoForm
            key={todoId}
            todoId={todoId}
            userId={this.props.userId}
            userStatus={this.props.userStatus}
            adminId={this.props.adminId}
            dataEntryContent={dataEntryTodo.dataEntryContent}
            onItemConfirmedOrStatusChange={this._onItemConfirmedOrStatusChange}
            disableDelete={true} // Always true for now unless in the future we want to support Admin undoing a user's mistake
          />
        ) :
          <span />;
      });
    }

    return (
      <div style={{ padding: '20px' }}>
        <big><div style={{ textAlign: "center" }}>{this.props.userStatus.name} | Id: {this.props.userId} | Email: {this.props.userStatus.email} | GMT {this.props.userStatus.timezoneOffset}</div></big>
        {uiOptions}
        <hr style={{ margin: '5px' }} />
        {selectedOptionUI}
        <NotesBox2 userId={this.props.userId} adminId={this.props.adminId} dataEntryMode={this.props.dataEntryMode} />
        {
          _.isEmpty(this.props.todoItems) ?
            <span /> :
            <div>
              {dataEntryTodoForms}
              <div style={{ color: "red" }}>{this.state.errorMessage}</div>
              <input
                type='submit'
                value='LOG EVERYTHING'
                onClick={this._onLogEverythingAsync}
                style={{
                  width: '500px',
                  fontSize: '20px',
                  padding: '10px',
                  margin: '10px'
                }}
                disabled={!this.state.everythingConfirmed && this.state.showLoadingMessage}
              >
              </input>
            </div>
        }
        <div style={{ textAlign: 'center', margin: '10px' }}>
          <big>Foods Logged On: <input type="date" value={this.state.targetDate} onChange={this._onTargetDateChange} /></big>
        </div>

          <div>
            <div style={{ textAlign: 'left', margin: '8px' }}>
              {
                _.get(this.state, 'foodTargets.calories.values[0]', null) !== null ?
                  <div>• [Calories] Total: {_.round(_.get(this.state, 'foodReports.calories.total', 0))} | Remaining: {_.round(_.get(this.state, 'foodReports.calories.remaining', 0))} | Week: {_.get(this.state, 'foodReportsAverages.calories', 0)}/{_.get(this.state, 'foodTargets.calories.values[0]', '?')} </div> :
                  <div>• [Calories] Total: {_.round(_.get(this.state, 'foodReports.calories.total', 0))} | No targets set </div>
              }

              {
                _.get(this.state, 'foodTargets.protein.values[0]', null) !== null ?
                  <div>• [Protein] Total: {_.round(_.get(this.state, 'foodReports.protein.total', 0))} | Remaining: {_.round(_.get(this.state, 'foodReports.protein.remaining', 0))} | Week: {_.get(this.state, 'foodReportsAverages.protein', 0)}/{_.get(this.state, 'foodTargets.protein.values[0]', '?')} </div> :
                  <div>• [Protein] Total: {_.round(_.get(this.state, 'foodReports.protein.total', 0))} | No targets set </div>
              }

              {
                _.get(this.state, 'foodTargets.carbs.values[0]', null) !== null ?
                  <div>• [Carbs] Total: {_.round(_.get(this.state, 'foodReports.carbs.total', 0))} | Remaining: {_.round(_.get(this.state, 'foodReports.carbs.remaining', 0))} | Week: {_.get(this.state, 'foodReportsAverages.carbs', 0)}/{_.get(this.state, 'foodTargets.carbs.values[0]', '?')} </div> :
                  <div>• [Carbs] Total: {_.round(_.get(this.state, 'foodReports.carbs.total', 0))} | No targets set </div>
              }

              {
                _.get(this.state, 'foodTargets.fat.values[0]', null) !== null ?
                  <div>• [Fat] Total: {_.round(_.get(this.state, 'foodReports.fat.total', 0))} | Remaining: {_.round(_.get(this.state, 'foodReports.fat.remaining', 0))} | Week: {_.get(this.state, 'foodReportsAverages.fat', 0)}/{_.get(this.state, 'foodTargets.fat.values[0]', '?')} </div> :
                  <div>• [Fat] Total: {_.round(_.get(this.state, 'foodReports.fat.total', 0))} | No targets set </div>
              }

              {
                _.get(this.state, 'foodTargets.water.values[0]', null) !== null ?
                  <div>• [Water] Total: {_.round(_.get(this.state, 'foodReports.water.total', 0))} | Remaining: {_.round(_.get(this.state, 'foodReports.water.remaining', 0))} | Week: {_.get(this.state, 'foodReportsAverages.water', 0)}/{_.get(this.state, 'foodTargets.water.values[0]', '?')} </div> :
                  <div>• [Water] Total: {_.round(_.get(this.state, 'foodReports.water.total', 0))} | No targets set </div>
              }
            </div>
            <hr />
          </div>

        <LoggedFoodsTable
          foods={this.state.allLoggedFoods}
          targetDate={this.state.targetDate}
          userId={this.props.userId}
          userStatus={this.props.userStatus}
          adminId={this.props.adminId}
          enableDateMigration={true}
          onDeleteFood={this._deleteFood}
          onCorrectFood={this._correctFood}
        />
        <hr />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/main/foodLogging/UserPanel2.js